import React from 'react';
import { IIconProps } from '../IIconProps';

export const PartnerIcon = ({ iconClass = '', title = '' }: IIconProps) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			version="1.1"
			viewBox="0 0 24 24"
			className={iconClass}
			fill="none"
		>
			{title && <title>{title}</title>}
			<path
				d="M16 19H15H0.5V16.5C0.5 14.567 4.358 13 8.5 13C10.673 13 12.6302 13.4313 14 14.1205"
				stroke="currentColor"
			/>
			<path
				d="M8.76758 13.5L9.8483 15.0807L8.76758 18L7.68686 15.0807L8.76758 13.5Z"
				stroke="currentColor"
			/>
			<path
				d="M11.5 7.5C11.5 9.15685 10.1569 10.5 8.5 10.5C6.84315 10.5 5.5 9.15685 5.5 7.5C5.5 5.84315 6.84315 4.5 8.5 4.5C10.1569 4.5 11.5 5.84315 11.5 7.5Z"
				stroke="currentColor"
			/>
			<path
				d="M18.3612 10V9.5H18.1512L18.0041 9.64996L18.3612 10ZM17.5294 10.8484L17.1724 10.4984L17.0294 10.6442V10.8484H17.5294ZM17.5294 11.8H17.0294V12.3H17.5294V11.8ZM20.4706 11.8V12.3H20.9706V11.8H20.4706ZM20.4706 10.8484H20.9706V10.6442L20.8276 10.4984L20.4706 10.8484ZM19.6388 10L19.9959 9.64996L19.8488 9.5H19.6388V10ZM14 13H13.5H14ZM14 17.8H13.5H14ZM22.3235 11.8V11.3V11.8ZM18.0041 9.64996L17.1724 10.4984L17.8864 11.1984L18.7182 10.35L18.0041 9.64996ZM17.0294 10.8484V11.8H18.0294V10.8484H17.0294ZM17.5294 12.3H20.4706V11.3H17.5294V12.3ZM20.9706 11.8V10.8484H19.9706V11.8H20.9706ZM20.8276 10.4984L19.9959 9.64996L19.2818 10.35L20.1136 11.1984L20.8276 10.4984ZM19.6388 9.5H18.3612V10.5H19.6388V9.5ZM15.1765 11.3C14.7286 11.3 14.3011 11.4816 13.9875 11.8014L14.7016 12.5015C14.8293 12.3713 15.0003 12.3 15.1765 12.3V11.3ZM13.9875 11.8014C13.6743 12.121 13.5 12.5523 13.5 13H14.5C14.5 12.8112 14.5736 12.6321 14.7016 12.5015L13.9875 11.8014ZM13.5 13V17.8H14.5V13H13.5ZM13.5 17.8C13.5 18.2477 13.6743 18.679 13.9875 18.9986L14.7016 18.2985C14.5736 18.1679 14.5 17.9888 14.5 17.8H13.5ZM13.9875 18.9986C14.3011 19.3184 14.7286 19.5 15.1765 19.5V18.5C15.0003 18.5 14.8293 18.4287 14.7016 18.2985L13.9875 18.9986ZM15.1765 19.5H22.3235V18.5H15.1765V19.5ZM22.3235 19.5C22.7714 19.5 23.1989 19.3184 23.5125 18.9986L22.7984 18.2985C22.6707 18.4287 22.4997 18.5 22.3235 18.5V19.5ZM23.5125 18.9986C23.8257 18.679 24 18.2477 24 17.8H23C23 17.9888 22.9264 18.1679 22.7984 18.2985L23.5125 18.9986ZM24 17.8V13H23V17.8H24ZM24 13C24 12.5523 23.8257 12.121 23.5125 11.8014L22.7984 12.5015C22.9264 12.6321 23 12.8112 23 13H24ZM23.5125 11.8014C23.1989 11.4816 22.7714 11.3 22.3235 11.3V12.3C22.4997 12.3 22.6707 12.3713 22.7984 12.5015L23.5125 11.8014ZM22.3235 11.3H15.1765V12.3H22.3235V11.3Z"
				fill="currentColor"
			/>
		</svg>
	);
};

// $bg-icon
